import { useContext, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { UserContext } from "../../../Context/UserContextAPI";
import { useQuery } from "@tanstack/react-query";
import request from "../../../utils/request";

const PrintMofa = () => {
  const { settingsData } = useContext(UserContext);

  const [searchParams] = useSearchParams();

  const fromDate = searchParams.get("fromDate");
  const toDate = searchParams.get("toDate");

  const { data: usersData = [] } = useQuery({
    queryKey: ["users", "MofaPrint", fromDate, toDate],
    queryFn: async () => {
      const query = new URLSearchParams({ fromDate, toDate }).toString();
      const res = await request.getAll(`v2/users/search-mofa-users?${query}`);
      return res.data || [];
    },
  });

  useEffect(() => {
    // Auto open print dialog
    setTimeout(() => {
      window.print();
    }, 1000);
    window.onafterprint = window.close;
  }, []);

  return (
    <div className=" p-4" style={{ backgroundColor: "white" }}>
      <div className="row align-items-center mb-2">
        <img
          src={`${process.env.REACT_APP_UPLOAD_URL}/${settingsData?.header_image}`}
          alt="Report Header"
          className="mx-auto"
          style={{ width: "100%" }}
        />
      </div>
      {/* HEADER */}
      <section className="held-up-certificate mb-3">
        <div
          className="text-center text-uppercase text-dark fs-5"
          style={{ fontWeight: "bolder" }}
        >
          Daily Statement of MOFA Uploaded Against Medically FIT Candidates for
          Saudi Arabia
        </div>
        <p className="text-center text-uppercase text-dark fs-6">
          Date: {format(new Date(fromDate), "dd-MM-yyyy")}
          {fromDate !== toDate && (
            <span> to {format(new Date(toDate), "dd-MM-yyyy")}</span>
          )}{" "}
          Country: KSA Status: FIT
        </p>
      </section>

      <p>GCC Code : {settingsData?.gcc_code}</p>

      {/* TABLE */}
      <table className="table table-bordered mt-4">
        <thead>
          <tr>
            <th>SL</th>
            <th>Name of the Candidate</th>
            <th>Passport No</th>
            <th>MOFA No</th>
            <th> Date of Upload</th>
          </tr>
        </thead>

        <tbody>
          {usersData.length === 0 ? (
            <tr>
              <td colSpan={5} className="text-center">
                No Data Found
              </td>
            </tr>
          ) : (
            usersData.map((user, index) => (
              <tr key={user.id || index}>
                <td>{index + 1}</td>
                <td>{user?.f_name}</td>
                <td>{user?.passport_no}</td>
                <td>{user?.mofa_no}</td>
                <td>
                  {user?.mofa_updated_at
                    ? format(new Date(user.mofa_updated_at), "dd-MM-yyyy")
                    : ""}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PrintMofa;
